module.exports = __webpack_public_path__ + "static/media/prazo3.e38b361e.png";